import { ProductRepository } from '../repositories/ProductRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class ProductFullLoadedUseCase {
    private productRepository: ProductRepository;
    private productId: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(productId: string) {
        this.productRepository = diContainer.get(serviceNames.productRepository);
        this.productId = productId;
    }

    public execute = () => {
        this.productRepository.updateProductId(this.productId);
    };
}
